module.exports = __webpack_public_path__ + "static/nuit-811f06d5a078a2e0c5dc8ba7e406a127.jpg";